<template>
  <div class="container">
    <!-- Search Box and Button -->
    <div class="dropdown-container">
      <!-- First Row -->
      <!-- <div class="dropdown-item">
        <label for="fsmSelect">FSM</label>
        <select id="fsmSelect" v-model="selectedFsm" @change="loadAsmList">
          <option value="">SELECT FSM</option>
          <option v-for="fsm in fsmList" :key="fsm.profile_id" :value="fsm.profile_id">
            {{ fsm.name || 'No Name Available' }}
          </option>
        </select>
      </div>

      <div class="dropdown-item">
        <label for="asmSelect">ASM</label>
        <select id="asmSelect" v-model="selectedAsm" @change="loadDistributorList">
          <option value="">SELECT ASM</option>
          <option v-for="asm in asmList" :key="asm.profile_id" :value="asm.profile_id">
            {{ asm.name || 'No Name Available' }}
          </option>
        </select>
      </div>

      <div class="dropdown-item">
        <label for="distributorSelect">Distributor</label>
        <select id="distributorSelect" v-model="selectedDistributor" @change="loadDealerList">
          <option value="">SELECT Distributor</option>
          <option v-for="distributor in distributorList" :key="distributor.profile_id" :value="distributor.profile_id">
            {{ distributor.name || 'No Name Available' }}
          </option>
        </select>
      </div>

      <div class="dropdown-item">
        <label for="dealerSelect">Dealer</label>
        <select id="dealerSelect" v-model="selectedDealer">
          <option value="">SELECT Dealer</option>
          <option v-for="dealer in dealerList" :key="dealer.profile_id" :value="dealer.profile_id">
            {{ dealer.name || 'No Name Available' }}
          </option>
        </select>
      </div> -->

      <!-- FSM -->
      <div class="dropdown-item">
        <label for="fsmSelect">FSM</label>
        <select id="fsmSelect" v-model="selectedFsm" @change="onFsmChange" :disabled="isFsmLocked">
          <option value="">SELECT FSM</option>

          <!-- ✅ All FSMs only for OTHER -->
          <option v-if="isOtherUser" :value="ALL">All FSMs</option>

          <option v-for="fsm in fsmList" :key="fsm.profile_id" :value="String(fsm.profile_id)">
            {{ fsm.name || "No Name Available" }}
          </option>
        </select>
      </div>

      <!-- ASM -->
      <div class="dropdown-item">
        <label for="asmSelect">ASM</label>
        <select id="asmSelect" v-model="selectedAsm" @change="onAsmChange" :disabled="isAsmLocked">
          <option value="">SELECT ASM</option>

          <!-- ✅ All ASMs for FSM / OTHER -->
          <option v-if="isFsmUser || isOtherUser" :value="ALL">All ASMs</option>

          <option v-for="asm in asmList" :key="asm.profile_id" :value="String(asm.profile_id)">
            {{ asm.name || "No Name Available" }}
          </option>
        </select>
      </div>

      <!-- Distributor -->
      <div class="dropdown-item">
        <label for="distributorSelect">Distributor</label>
        <select id="distributorSelect" v-model="selectedDistributor" @change="onDistributorChange"
          :disabled="isDistributorLocked">
          <option value="">SELECT Distributor</option>

          <!-- ✅ All Distributors for FSM / ASM / OTHER -->
          <option v-if="isFsmUser || isAsmUser || isOtherUser" :value="ALL">All Distributors</option>

          <option v-for="d in distributorList" :key="d.profile_id" :value="String(d.profile_id)">
            {{ d.name || "No Name Available" }}
          </option>
        </select>
      </div>

      <!-- Dealer -->
      <div class="dropdown-item">
        <label for="dealerSelect">Dealer</label>
        <select id="dealerSelect" v-model="selectedDealer" :disabled="!canUseDealerFilter">
          <option value="">All Dealers</option>
          <option v-for="dealer in dealerList" :key="dealer.profile_id" :value="String(dealer.profile_id)">
            {{ dealer.name || "No Name Available" }}
          </option>
        </select>
      </div>



      <!-- Second Row -->
      <div class="dropdown-item">
        <label for="complaintNo">Complaint No</label>
        <input type="text" v-model="searchQuery" placeholder="Search..." class="search-input"
          @keydown.enter="performSearch" />
      </div>

      <div class="dropdown-item">
        <label for="startDatePicker">Start Date</label>
        <input type="date" v-model="startDate" class="search-input" @change="handleDateChange" :max="currentDate"
          @blur="validateStartDate" />
      </div>

      <div class="dropdown-item">
        <label for="endDatePicker">End Date</label>
        <input type="date" v-model="endDate" class="search-input" @change="handleDateChange" :max="currentDate"
          @blur="validateEndDate" />
      </div>

      <div class="dropdown-item search-container">
        <button @click="onSearchClick" class="btn button-default mt-4" :disabled="loading">
          {{ loading ? "Searching..." : "Search" }}
        </button>

      </div>
    </div>

    <!-- Loading Spinner -->
    <div v-if="loading" class="loading-spinner">
      <i class="fa fa-spinner fa-spin"></i> Loading...
    </div>

    <!-- Complaint Table -->
    <div v-else class="table-container">
      <div v-if="complaintList.length > 0" class="card">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr class="border-bottom-primary">
                <th scope="col">Complaint No</th>
                <th scope="col">Sent Date & Time</th>
                <th scope="col">Sender's Name</th>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in filteredComplaintList" :key="index">
                <td>{{ item.complaint.complaine_no }}</td>
                <td>{{ formatDate(item.complaint.created_at) }}</td>
                <td>{{ item.complaint.business_name }}</td>
                <td><span :class="statusClass(item.complaint.status)">{{ item.complaint.status.toUpperCase() }}</span>
                </td>
                <td>
                  <i @click="viewDetails(item.complaint.id, item.histories)" class="fa fa-eye" aria-hidden="true"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else class="no-complaints text-center">
        No complaints found.
      </div>
    </div>

    <!-- Modal Component -->
    <Modal :visible="showModal" :title="modalTitle" :identifier-label="modalIdentifierLabel"
      :identifier-value="modalIdentifierValue" :message-label="modalMessageLabel" :message-value="modalMessageValue"
      :status-label="modalStatusLabel" :status-value="modalStatusValue" :date-time-label="modalDateTimeLabel"
      :date-time-value="modalDateTimeValue" :complaintId="modalComplaintId" :delarname-label="modaldelarnameLabel"
      :delarname-value="modaldelarnameValue" :histories="modalHistories" @close="showModal = false" />
  </div>
</template>

<script>
import {
  fetchFsmList,
  fetchAsmList,
  fetchDistributorList,
  fetchDealerListManagement,
  searchComplaints
} from '@/services/dataService';
import Modal from '../Modal/viewComplaint.vue';
import { ref } from "vue";
import { useToast } from "vue-toastification";

export default {
  components: {
    Modal,
  },

  data() {
    const currentDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
    const ALL = "__all__";
    return {
      token: localStorage.getItem('token_set') || '', //current token
      fsmList: [],
      asmList: [],
      distributorList: [],
      dealerList: [],
      selectedFsm: '',
      selectedAsm: '',
      selectedDistributor: '',
      selectedDealer: '',
      searchQuery: '',
      startDate: currentDate,
      endDate: currentDate,
      complaintList: [],
      loading: false,
      showModal: false,
      modalTitle: '',
      currentDate,
      modalIdentifierLabel: '',
      modalIdentifierValue: '',
      modalMessageLabel: '',
      modalMessageValue: '',
      modalStatusLabel: '',
      modalStatusValue: '',
      modalDateTimeLabel: '',
      modalDateTimeValue: '',
      modalComplaintId: null,
      modaldelarnameLabel: '',
      modaldelarnameValue: '',
      modalHistories: [],


      ALL,
      userLabel: "",
      roleKey: "OTHER",
      myProfileId: Number(localStorage.getItem("profile_id") || 0),
      isFsmLocked: false,
      isAsmLocked: false,
      isDistributorLocked: false,
      searchedOnce: false,
    };
  },

  watch: {
    showModal(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
  },

  created() {
    this.initRoleFromStorage();
    this.fetchInitialData();
    this.performSearch({ userAction: false });
  },


  computed: {

    isDistributorUser() { return this.roleKey === "DIS"; },
    isAsmUser() { return this.roleKey === "ASM"; },
    isFsmUser() { return this.roleKey === "FSM"; },
    isOtherUser() { return this.roleKey === "OTHER"; },

    // ✅ dealer enabled only when real distributor selected
    canUseDealerFilter() {
      return !!this.selectedDistributor && this.selectedDistributor !== this.ALL;
    },


    filteredComplaintList() {
      if (!Array.isArray(this.complaintList)) {
        return [];
      }
      return this.complaintList.filter((complaint) => {
        const complaintDate = this.formatDateForComparison(complaint.complaint.created_at);
        const startDate = this.startDate ? this.formatDateForComparison(this.startDate) : null;
        const endDate = this.endDate ? this.formatDateForComparison(this.endDate) : null;

        if (startDate && endDate) {
          return complaintDate >= startDate && complaintDate <= endDate;
        } else if (startDate) {
          return complaintDate >= startDate;
        } else if (endDate) {
          return complaintDate <= endDate;
        } else {
          return true;
        }
      });
    },
  },

  methods: {
    //Date Range Validation
    handleDateChange() {
      if (this.startDate && this.endDate) {
        const start = new Date(this.startDate);
        const end = new Date(this.endDate);

        if (end < start) {
          this.showErrorToast('Invalid date range picked.');
          this.endDate = ''; // Clear the invalid end date
        }
      }
    },


    initRoleFromStorage() {
      const labelFromStorage =
        localStorage.getItem("user_label") ||
        localStorage.getItem("userLabel") ||
        localStorage.getItem("role") ||
        "";

      this.userLabel = String(labelFromStorage);
      const u = this.userLabel.toUpperCase().trim();

      if (u === "DISTRIBUTOR" || u.startsWith("DISTRIBUTOR") || u === "DIS" || u.startsWith("DIS_")) this.roleKey = "DIS";
      else if (u === "ASM" || u.startsWith("ASM_")) this.roleKey = "ASM";
      else if (u === "FSM" || u.startsWith("FSM_")) this.roleKey = "FSM";
      else this.roleKey = "OTHER";
    },

    validateFiltersOneByOne() {
      if (!this.selectedFsm) { this.showErrorToast("Please select FSM"); return false; }
      if (!this.selectedAsm) { this.showErrorToast("Please select ASM"); return false; }
      if (!this.selectedDistributor) { this.showErrorToast("Please select Distributor"); return false; }

      // ✅ distributor user cannot choose ALL
      if (this.isDistributorUser && this.selectedDistributor === this.ALL) {
        this.showErrorToast("Please select Distributor");
        return false;
      }

      // dealer optional (All Dealers allowed)
      return true;
    },

    showSuccessToast(message) {
      const toast = useToast();
      toast.success(message, {
        position: "top-right",
        timeout: 3000,
      });
    },


    isValidISODate(dateStr) {
      if (!dateStr || typeof dateStr !== "string") return false;
      if (dateStr.includes("/")) return false;

      const m = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!m) return false;

      const y = Number(m[1]);
      const mo = Number(m[2]);
      const d = Number(m[3]);

      const dt = new Date(y, mo - 1, d);
      return dt.getFullYear() === y && dt.getMonth() === mo - 1 && dt.getDate() === d;
    },

    validateStartDate(showToast = true) {
      if (!this.startDate) return true;

      if (!this.isValidISODate(this.startDate)) {
        if (showToast) this.showErrorToast("Invalid Start Date");
        this.startDate = "";
        return false;
      }

      if (this.startDate > this.currentDate) {
        if (showToast) this.showErrorToast("Start Date cannot be in the future");
        this.startDate = "";
        return false;
      }

      return true;
    },

    validateEndDate(showToast = true) {
      if (!this.endDate) return true;

      if (!this.isValidISODate(this.endDate)) {
        if (showToast) this.showErrorToast("Invalid End Date");
        this.endDate = "";
        return false;
      }

      if (this.endDate > this.currentDate) {
        if (showToast) this.showErrorToast("End Date cannot be in the future");
        this.endDate = "";
        return false;
      }

      return true;
    },

    handleDateChange() {
      this.validateStartDate(false);
      this.validateEndDate(false);

      if (this.startDate && this.endDate && this.endDate < this.startDate) {
        this.showErrorToast("Invalid date range picked.");
        this.endDate = "";
      }
    },

    validateDatesForSearch() {
      // ✅ REQUIRED dates (same pattern)
      if (!this.startDate) { this.showErrorToast("Please select valid Start Date"); return false; }
      if (!this.endDate) { this.showErrorToast("Please select valid End Date"); return false; }

      if (!this.validateStartDate(true)) return false;
      if (!this.validateEndDate(true)) return false;

      if (this.endDate < this.startDate) {
        this.showErrorToast("Invalid date range picked.");
        return false;
      }
      return true;
    },


    //Show Error Message in Toaster
    showErrorToast(message) {
      const toast = useToast(); // Initialize toaster
      toast.error(message, {
        position: "top-right",
        timeout: 3000,
      });
    },

    //Call first time call API
    async fetchInitialData() {
      try {
        await this.loadFsmList();
      } catch (error) {
        console.error('Error fetching initial data:', error);
      }
    },

    //Fetch FSM List
    // async loadFsmList() {
    //   const profileId = localStorage.getItem('profile_id');
    //   if (!profileId) {
    //     console.error('Profile ID not found in localStorage');
    //     return;
    //   }
    //   try {
    //     const response = await fetchFsmList(profileId, this.token);
    //     this.fsmList = response.data.data || [];

    //     // if dropdown have only one option select it
    //     if (this.fsmList.length === 1) {
    //       this.selectedFsm = this.fsmList[0].profile_id;
    //       await this.loadAsmList();
    //     }

    //   } catch (error) {
    //     console.error('Error loading FSM list:', error);
    //   }
    // },

    //Fetch ASM List
    // async loadAsmList() {
    //   if (this.selectedFsm) {
    //     try {
    //       const profileId = localStorage.getItem('profile_id');
    //       const response = await fetchAsmList(profileId, this.selectedFsm, this.token);
    //       this.asmList = response.data.data || [];
    //       this.selectedAsm = '';
    //       this.selectedDistributor = '';
    //       this.selectedDealer = '';

    //       // if dropdown have only one option select it
    //       if (this.asmList.length === 1) {
    //         this.selectedAsm = this.asmList[0].profile_id;
    //         await this.loadDistributorList();
    //       }

    //     } catch (error) {
    //       console.error('Error loading ASM list:', error);
    //     }
    //   } else {
    //     this.asmList = [];
    //     this.selectedAsm = '';
    //     this.selectedDistributor = '';
    //     this.selectedDealer = '';
    //   }
    // },

    //Fetch Distributors List
    // async loadDistributorList() {
    //   if (this.selectedAsm) {
    //     try {
    //       const fsmId = this.selectedFsm;
    //       const response = await fetchDistributorList(fsmId, this.selectedAsm, this.token);
    //       this.distributorList = response.data.data || [];
    //       this.selectedDistributor = '';
    //       this.selectedDealer = '';

    //       // if dropdown have only one option select it
    //       if (this.distributorList.length === 1) {
    //         this.selectedDistributor = this.distributorList[0].profile_id;
    //         await this.loadDealerList();
    //       }

    //     } catch (error) {
    //       console.error('Error loading Distributor list:', error);
    //     }
    //   } else {
    //     this.distributorList = [];
    //     this.selectedDistributor = '';
    //     this.selectedDealer = '';
    //   }
    // },
    // async loadDistributorList() {
    //   // reset below-level selections + lists first
    //   this.selectedDistributor = "";
    //   this.selectedDealer = "";
    //   this.distributorList = [];
    //   this.dealerList = [];
    //   this.isDistributorLocked = false;

    //   // if no ASM selected -> keep cleared
    //   if (!this.selectedAsm) return;

    //   // if ASM is ALL -> allow distributor ALL and stop (no list needed)
    //   if (this.selectedAsm === this.ALL) {
    //     this.selectedDistributor = this.ALL;
    //     return;
    //   }

    //   try {
    //     const fsmId = this.selectedFsm; // can be normal value (you already validate FSM)
    //     const res = await fetchDistributorList(fsmId, this.selectedAsm, this.token);

    //     let list = res?.data?.data || [];

    //     // ✅ Distributor login: lock to own distributor (NO "ALL")
    //     if (this.isDistributorUser && this.myProfileId) {
    //       const mine = list.find(d => Number(d.profile_id) === Number(this.myProfileId));
    //       if (mine) {
    //         list = [mine];
    //         this.selectedDistributor = String(mine.profile_id);
    //         this.isDistributorLocked = true;

    //         // programmatic set doesn't trigger @change
    //         await this.loadDealerList();
    //       }
    //     } else {
    //       // ✅ keep old behavior only for non-distributor users:
    //       // auto select if exactly one distributor
    //       if (list.length === 1) {
    //         this.selectedDistributor = String(list[0].profile_id);
    //         await this.loadDealerList();
    //       }
    //     }

    //     this.distributorList = list;
    //   } catch (error) {
    //     console.error("Error loading Distributor list:", error);
    //     this.distributorList = [];
    //     this.selectedDistributor = "";
    //     this.selectedDealer = "";
    //     this.isDistributorLocked = false;
    //   }
    // },


    //Fetch Dealers List
    // async loadDealerList() {
    //   if (this.selectedDistributor) {
    //     try {
    //       const profileId = localStorage.getItem('profile_id');
    //       const token = ref(localStorage.getItem('token_set') || '');
    //       const response = await fetchDealerListManagement(profileId, this.selectedDistributor, token.value);
    //       this.dealerList = response.data.data || [];
    //       this.selectedDealer = '';

    //       // if dropdown have only one option select it
    //       if (this.dealerList.length === 1) {
    //         this.selectedDealer = this.dealerList[0].profile_id;
    //       }

    //     } catch (error) {
    //       console.error('Error loading dealer_visit list:', error);
    //     }
    //   } else {
    //     this.dealerList = [];
    //     this.selectedDealer = '';
    //   }
    // },



    // -------------------- FSM --------------------
    async loadFsmList() {
      const profileId = localStorage.getItem("profile_id");
      if (!profileId) return;

      try {
        const res = await fetchFsmList(profileId, this.token);
        this.fsmList = res?.data?.data || [];

        // ✅ ALWAYS manual selection (no auto select)
        this.selectedFsm = "";
        this.selectedAsm = "";
        this.selectedDistributor = "";
        this.selectedDealer = "";

        this.asmList = [];
        this.distributorList = [];
        this.dealerList = [];

        this.isDistributorLocked = false;
      } catch (e) {
        console.error("Error loading FSM list:", e);
      }
    },

    async onFsmChange() {
      // reset below
      this.selectedAsm = "";
      this.selectedDistributor = "";
      this.selectedDealer = "";

      this.asmList = [];
      this.distributorList = [];
      this.dealerList = [];
      this.isDistributorLocked = false;

      if (!this.selectedFsm) return;

      // ✅ If FSM = ALL → user can manually pick ASM = ALL (asmList stays empty)
      if (this.selectedFsm === this.ALL) return;

      await this.loadAsmList();
    },

    // -------------------- ASM --------------------
    async loadAsmList() {
      // clear below every time we load ASM list
      this.selectedAsm = "";
      this.selectedDistributor = "";
      this.selectedDealer = "";

      this.distributorList = [];
      this.dealerList = [];
      this.isDistributorLocked = false;

      if (!this.selectedFsm || this.selectedFsm === this.ALL) return;

      try {
        const profileId = localStorage.getItem("profile_id");
        const res = await fetchAsmList(profileId, this.selectedFsm, this.token);
        this.asmList = res?.data?.data || [];

        // ✅ ALWAYS manual selection (no auto select)
      } catch (e) {
        console.error("Error loading ASM list:", e);
        this.asmList = [];
      }
    },

    async onAsmChange() {
      // reset below
      this.selectedDistributor = "";
      this.selectedDealer = "";

      this.distributorList = [];
      this.dealerList = [];
      this.isDistributorLocked = false;

      if (!this.selectedAsm) return;

      // ✅ If ASM = ALL → user can manually pick Distributor = ALL (distributorList stays empty)
      if (this.selectedAsm === this.ALL) return;

      await this.loadDistributorList();
    },

    // -------------------- Distributor --------------------
    async loadDistributorList() {
      // reset below
      this.selectedDistributor = "";
      this.selectedDealer = "";
      this.distributorList = [];
      this.dealerList = [];
      this.isDistributorLocked = false;

      // must have real ASM (not ALL)
      if (!this.selectedAsm || this.selectedAsm === this.ALL) return;

      try {
        const fsmId = this.selectedFsm; // should be real FSM (not ALL) because distributor list depends on it
        const res = await fetchDistributorList(fsmId, this.selectedAsm, this.token);

        let list = res?.data?.data || [];

        // ✅ ONLY Distributor login: lock own distributor (still requires user to select FSM + ASM manually)
        if (this.isDistributorUser && this.myProfileId) {
          const mine = list.find(d => Number(d.profile_id) === Number(this.myProfileId));
          if (mine) {
            list = [mine];
            this.selectedDistributor = String(mine.profile_id);
            this.isDistributorLocked = true;

            // load dealers for locked distributor (dealer remains All Dealers)
            await this.loadDealerList();
          }
        }

        // ✅ everyone else: NO auto select even if list.length === 1
        this.distributorList = list;
      } catch (e) {
        console.error("Error loading Distributor list:", e);
        this.distributorList = [];
        this.selectedDistributor = "";
        this.selectedDealer = "";
        this.isDistributorLocked = false;
      }
    },

    async onDistributorChange() {
      this.selectedDealer = "";
      this.dealerList = [];

      if (!this.selectedDistributor) return;
      if (this.selectedDistributor === this.ALL) return; // dealer disabled anyway

      await this.loadDealerList();
    },

    // -------------------- Dealer --------------------
    async loadDealerList() {
      this.dealerList = [];
      this.selectedDealer = ""; // keep "All Dealers"

      // only load dealers if real distributor selected
      if (!this.selectedDistributor || this.selectedDistributor === this.ALL) return;

      try {
        const profileId = localStorage.getItem("profile_id");
        const res = await fetchDealerListManagement(profileId, this.selectedDistributor, this.token);
        this.dealerList = res?.data?.data || [];

        // ✅ NO auto select dealer even if only 1
      } catch (e) {
        console.error("Error loading Dealer list:", e);
        this.dealerList = [];
        this.selectedDealer = "";
      }
    },



    //Data filtering API Call
    // async performSearch() {
    //   this.loading = true;
    //   try {
    //     const searchParams = {
    //       fsm_id: this.selectedFsm || null,
    //       asm_id: this.selectedAsm || null,
    //       distributor_id: this.selectedDistributor || null,
    //       dealer_id: this.selectedDealer || null,
    //       complaint_no: this.searchQuery || null,
    //       start_date: this.formatDateForApi(this.startDate),
    //       end_date: this.formatDateForApi(this.endDate),
    //     };

    //     const response = await searchComplaints(searchParams, this.token);
    //     this.complaintList = response.data.data || [];
    //   } catch (error) {
    //     console.error('Error searching complaint:', error);
    //   } finally {
    //     this.loading = false;
    //   }
    // },

    async onSearchClick() {
      await this.performSearch({ userAction: true }); // ✅ validations only on user click
    },

    async performSearch({ userAction = false } = {}) {
      // ✅ Only validate filters when user clicks Search
      if (userAction) {
        if (!this.validateFiltersOneByOne()) {
          this.searchedOnce = true;
          return;
        }

        if (!this.validateDatesForSearch()) {
          this.searchedOnce = true;
          return;
        }
      } else {
        // initial load: do NOT show "Please select FSM"
        // (dates are already defaulted, so it's safe)
      }

      this.loading = true;
      this.searchedOnce = false;

      try {
        const searchParams = {
          fsm_id: (this.selectedFsm && this.selectedFsm !== this.ALL) ? this.selectedFsm : null,
          asm_id: (this.selectedAsm && this.selectedAsm !== this.ALL) ? this.selectedAsm : null,
          distributor_id: (this.selectedDistributor && this.selectedDistributor !== this.ALL) ? this.selectedDistributor : null,
          dealer_id: this.selectedDealer || null,
          complaint_no: this.searchQuery || null,
          start_date: this.formatDateForApi(this.startDate),
          end_date: this.formatDateForApi(this.endDate),
        };

        const response = await searchComplaints(searchParams, this.token);
        this.complaintList = response?.data?.data || [];

        // ✅ Success toast (only when user clicked search)
        if (userAction && this.complaintList.length) {
          this.showSuccessToast("Report Generated Successfully");
        }

        // Optional: user clicked search but no results
        if (userAction && !this.complaintList.length) {
          this.showErrorToast("No complaints found.");
        }

      } catch (error) {
        console.error("Error searching complaint:", error);
        if (userAction) this.showErrorToast("Error loading report.");
      } finally {
        this.loading = false;
        this.searchedOnce = true;
      }
    },


    //Get date from API
    formatDateForApi(dateString) {
      if (!dateString) return null; // Return null if date is empty

      const date = new Date(dateString);
      if (isNaN(date)) {
        console.error('Invalid date:', dateString);
        return null; // Return null for invalid dates
      }
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },

    //Date time comparison
    formatDateForComparison(dateString) {
      return new Date(dateString).toISOString().split('T')[0]; // YYYY-MM-DD format for comparison
    },

    //Date Time Formatter
    formatDate(dateString) {
      if (!dateString) return 'Invalid Date'; // Return a fallback if date is empty

      const date = new Date(dateString);
      if (isNaN(date)) {
        console.error('Invalid date:', dateString);
        return 'Invalid Date'; // Return fallback for invalid dates
      }

      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);

      let hours = date.getHours();
      const minutes = ('0' + date.getMinutes()).slice(-2);
      const seconds = ('0' + date.getSeconds()).slice(-2);
      const ampm = hours >= 12 ? 'PM' : 'AM';

      hours = hours % 12 || 12; // Convert to 12-hour format
      const formattedHours = ('0' + hours).slice(-2);

      return `${year}-${month}-${day} | ${formattedHours}:${minutes}:${seconds} ${ampm}`;
    },

    //Show status badge
    statusClass(status) {
      const normalizedStatus = status.toLowerCase();

      if (normalizedStatus === 'inprogress') return 'badge badge-inprogress' // No badge class was defined for 'inprogress', can be added later if needed.
      if (normalizedStatus === 'pending') return 'badge badge-pending'; // #ff9800
      if (normalizedStatus === 'completed') return 'badge badge-completed'; // #28a745

      return 'badge badge-secondary'; // Default fallback
    },

    //View complaint details
    viewDetails(complaintId, histories) {
      if (complaintId) {
        const selectedComplaint = this.complaintList.find(item => item.complaint.id === complaintId);
        if (selectedComplaint) {
          this.modalTitle = `View Complaint`;
          this.modalComplaintId = complaintId;
          this.modalIdentifierLabel = 'Complaint No';
          this.modalIdentifierValue = selectedComplaint.complaint.complaine_no;
          this.modaldelarnameLabel = 'Complaint Sent by';
          this.modaldelarnameValue = selectedComplaint.complaint.business_name;
          this.modalMessageLabel = 'Complaint';
          this.modalMessageValue = selectedComplaint.complaint.complaines;
          this.modalStatusLabel = 'Status';
          this.modalStatusValue = selectedComplaint.complaint.status.toUpperCase();
          this.modalDateTimeLabel = 'Sent Date & Time';
          this.modalDateTimeValue = this.formatDate(selectedComplaint.complaint.created_at);

          //Show details of the complaint when it in-progress and completed.
          const statusLower = selectedComplaint.complaint.status.toLowerCase();
          if (statusLower === 'inprogress') {
            this.modalHistories = selectedComplaint.histories.length > 0
              ? [{
                replyValue: selectedComplaint.histories[1].description,
                replySentByValue: selectedComplaint.histories[1].business_name,
                replyDateTimeValue: this.formatDate(selectedComplaint.histories[1].date_time),
              }]
              : [];
          } else if (statusLower === 'completed') {
            this.modalHistories = selectedComplaint.histories.length > 0
              ? [{
                replyValue: selectedComplaint.histories[1].description,
                replySentByValue: selectedComplaint.histories[1].business_name,
                replyDateTimeValue: this.formatDate(selectedComplaint.histories[1].date_time),
                completedBy: selectedComplaint.histories[2].business_name,
                completedDateTime: this.formatDate(selectedComplaint.histories[2].date_time),
              }]
              : [];
          }
          this.showModal = true;
        }
      }
    }
  },
};
</script>

<style scoped>
/* Ensure the body and html take the full height of the page */
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #f0f0f0;
  /* Background color for the page */
}

/* Container for the entire section */
.container {
  background-color: #ffffff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 20px;
  margin: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* Center items vertically */
  height: 100%;
  /* Take full height of the page */
  width: 100%;
  /* Take full width of the page */
  box-sizing: border-box;
  /* Ensure padding doesn't affect width */
}

/* Loading spinner styles */
.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
  color: #007bff;
  /* Preserved color for spinner */
}

/* Container for dropdowns and search box */
.dropdown-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  /* 4 columns for each row */
  gap: 15px;
  /* Adjust spacing between items */
  width: 100%;
  /* Ensure container takes full width */
  justify-content: center;
  /* Center dropdowns horizontally */
  margin-bottom: 20px;
  /* Space between dropdowns and table */
}

/* Each dropdown item with label */
.dropdown-item {
  flex: 1;
  min-width: 180px;
  /* Minimum width for each dropdown item */
  max-width: 250px;
  /* Maximum width for each dropdown item */
}

/* Styling for labels */
label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 14px;
  /* Adjust font size for better readability */
}

/* Styling for select elements */
select {
  width: 100%;
  /* Ensure select takes full width of its container */
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  /* Adjust font size for better readability */
  transition: border-color 0.3s, box-shadow 0.3s;
}

input[type="date"] {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  width: 100%;
}

input[type="text"] {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  width: 100%;
}

/* Focus styling for select elements */
select:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

/* Styling for search input */
.search-input {
  flex: 1;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  /* Adjust font size for better readability */
  transition: border-color 0.3s, box-shadow 0.3s;
}

/* Focus styling for search input */
.search-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
  /* Remove the default outline */
}

/* Styling for search button */
.search-container {
  display: flex;
  align-items: center;
  justify-content: left;
}

.btn.button-default {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: #ffffff;
  font-size: 14px;
  /* Adjust font size for better readability */
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;
}

.btn.button-default:hover {
  background-color: #0056b3;
  transform: scale(1.05);
}

.btn.button-default:active {
  transform: scale(0.95);
}

/* Table styling */
.table-container {
  width: 100%;
  margin-top: 20px;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.table th {
  background-color: #f9f9f9;
  font-weight: bold;
}

.table td {
  background-color: #ffffff;
}

/* Popup styling */
.popup-content h3 {
  margin-top: 0;
}

.popup-content ul {
  list-style: none;
  padding: 0;
}

.popup-content li {
  margin-bottom: 10px;
}

.popup-content hr {
  border: 0;
  border-top: 1px solid #ddd;
  margin: 10px 0;
}

/* Optional: Add spacing and icon styling for the complaint messages */
.table td i.fa-flag {
  margin-right: 8px;
  /* Space between icon and text */
  color: red;
  /* Color of the flag icon */
}

/* Styling for the "eye" icon */
.fa-eye {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
  /* Smooth transition for color and transform */
}

/* Hover effect for the "eye" icon */
.fa-eye:hover {
  color: #0056b3;
  /* Darker shade on hover */
  transform: scale(1.2);
  /* Slightly enlarge the icon on hover */
}

/* Active effect for the "eye" icon */
.fa-eye:active {
  transform: scale(1.1);
  /* Slightly shrink the icon on click */
}

.badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 5px;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 100px;
  max-width: 100px;
}

.badge-pending {
  background-color: #ff9800;
}

.badge-inprogress {
  background-color: #007bff;
}

.badge-completed {
  background-color: #28a745;
}
</style>